import ApiClient from "../aquaart-group";
import { ResponseFormType } from "@/api/feedback/types";
import { ApplicationResource } from "../generated-api";

export class ApiFeedback {
  static async postFeedback(lang: string, form: ApplicationResource): Promise<ResponseFormType> {
    return ApiClient.post("/application/create", form);
  }
}
